import type {
    GetDriveItemsResponseType,
    GetDriveItemsRequestType
} from "./type";
import {
    request
} from "../request";

const getDriveItems = async (params: GetDriveItemsRequestType) => {
    return await request<GetDriveItemsResponseType>("/drive/getDriveItems", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default getDriveItems;
